// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostItem_wrapper__2F6x3","image":"PostItem_image__t12Vo","content":"PostItem_content__bHfxy","date":"PostItem_date__28opp","title":"PostItem_title__1dRmb"};